import React from 'react'
import InvitaionFormPage from '../../components/Admin/InvitationForm';

const InvitationForm = () => {
  return (
    <InvitaionFormPage />
  )
}

export default InvitationForm;